import Vue from 'vue'

const store = Vue.observable({
  cID: null,
  token: null,
  profiles: [],
  loading: false,
  customerCountry: 'NZ',
})

const actions = {
  initProfiles() {
    fetch('/collections/all?view=profiles')
      .then(res => res.json())
      .then(data => {
        store.cID = data.customer_id
        store.token = data.access_token
        store.profiles = data.profiles
        store.loading = false
      })
      .catch(error => {
        console.error(error)
      })
  },

  saveProfile(profile) {
    store.loading = true

    let endpoint = `/tools/ps/customer/${store.cID}/metafields`
    let method = 'POST'

    let data = []
    if (store.profiles.length) {
      for (let p of store.profiles) {
        if (p.fullname === profile.fullname) {
          data.push(profile)
          continue
        } else {
          data.push(p)
        }
      }
    }

    fetch(endpoint, {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'custom-token': store.token,
      },
      body: JSON.stringify({
        namespace: 'pscustomer',
        key: 'profiles',
        value: data,
        type: 'json',
      }),
    })
      .then(res => res.json())
      .then(data => {
        actions.initProfiles()
      })
      .catch(error => {
        console.error('Error:', error)
      })
  },

  createProfile(profile) {
    store.loading = true

    let endpoint = `/tools/ps/customer/${store.cID}/metafields`
    let method = 'POST'

    let data = []
    if (store.profiles.length) {
      data.push(...store.profiles)
      data.push(profile)
    } else {
      data.push(profile)
    }

    fetch(endpoint, {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'custom-token': store.token,
      },
      body: JSON.stringify({
        namespace: 'pscustomer',
        key: 'profiles',
        value: data,
        type: 'json',
      }),
    })
      .then(res => res.json())
      .then(data => {
        actions.initProfiles()
      })
      .catch(error => {
        console.error('Error:', error)
      })
  },

  deleteProfile(profile) {
    store.loading = true

    let endpoint = `/tools/ps/customer/${store.cID}/metafields`
    let method = 'POST'

    let data = []
    if (store.profiles.length) {
      for (let p of store.profiles) {
        if (p.fullname === profile.fullname) {
          continue
        } else {
          data.push(p)
        }
      }
    }

    fetch(endpoint, {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'custom-token': store.token,
      },
      body: JSON.stringify({
        namespace: 'pscustomer',
        key: 'profiles',
        value: data,
        type: 'json',
      }),
    })
      .then(res => res.json())
      .then(data => {
        actions.initProfiles()
      })
      .catch(error => {
        console.error('Error:', error)
      })
  },
}

Vue.prototype.$store = store
Vue.prototype.$actions = actions
